export default {
    warnings: {
        straightRow: 'Gerade Linien von Tasten auf der Tastatur sind leicht zu erraten.',
        keyPattern: 'Kurze Tastaturmuster sind leicht zu erraten.',
        simpleRepeat: 'Sich wiederholende Zeichen wie "aaa" sind leicht zu erraten.',
        extendedRepeat: 'Sich wiederholende Zeichenmuster wie "abcabcabc" sind leicht zu erraten.',
        sequences: 'Häufige Zeichenfolgen wie "abc" sind leicht zu erraten.',
        recentYears: 'Die jüngsten Jahreszahlen sind leicht zu erraten.',
        dates: 'Ein Datum ist leicht zu erraten.',
        topTen: 'Dies ist ein sehr häufig verwendetes Passwort.',
        topHundred: 'Dies ist ein häufig verwendetes Passwort.',
        common: 'Dies ist ein oft verwendetes Passwort.',
        similarToCommon: 'Dies weist Ähnlichkeit zu anderen oft verwendeten Passwörtern auf.',
        wordByItself: 'Einzelne Wörter sind leicht zu erraten.',
        namesByThemselves: 'Einzelne Namen oder Nachnamen sind leicht zu erraten.',
        commonNames: 'Vornamen und Nachnamen sind leicht zu erraten.',
        userInputs: 'Es sollten keine persönlichen oder Seiten relevanten Daten vorkommen.',
        pwned: 'Ihr Kennwort wurde durch eine Datenpanne im Internet offengelegt.',
    },
    suggestions: {
        l33t: "Vorhersehbare Buchstabenersetzungen wie '@' für 'a' vermeiden.",
        reverseWords: 'Umgekehrte Schreibweise von gebräuchlichen Wörtern vermeiden.',
        allUppercase: 'Einige, aber nicht alle Buchstaben groß schreiben.',
        capitalization: 'Nicht nur den ersten Buchstaben groß schreiben.',
        dates: 'Daten, die mit persönlichen Daten in Verbindung gebracht werden können, vermeiden.',
        recentYears: 'Die jüngsten Jahreszahlen vermeiden.',
        associatedYears: 'Jahre, die mit persönlichen Daten in Verbindung gebracht werden können, vermeiden.',
        sequences: 'Häufige Zeichenfolgen vermeiden.',
        repeated: 'Wort- und Zeichenwiederholungen vermeiden.',
        longerKeyboardPattern: 'Längere Tastaturmuster in unterschiedlicher Tipprichtung verwenden.',
        anotherWord: 'Weitere Wörter, die weniger häufig vorkommen, hinzufügen.',
        useWords: 'Mehrere Wörter verwenden, aber allgemeine Phrasen vermeiden.',
        noNeed: 'Es ist möglich, starke Passwörter zu erstellen, ohne Symbole, Zahlen oder Großbuchstaben zu verwenden.',
        pwned: 'Wenn Sie dieses Kennwort an anderer Stelle verwenden, sollten Sie es ändern.',
    },
    timeEstimation: {
        ltSecond: 'weniger als eine Sekunde',
        second: '{base} Sekunde',
        seconds: '{base} Sekunden',
        minute: '{base} Minute',
        minutes: '{base} Minuten',
        hour: '{base} Stunde',
        hours: '{base} Stunden',
        day: '{base} Tag',
        days: '{base} Tage',
        month: '{base} Monat',
        months: '{base} Monate',
        year: '{base} Jahr',
        years: '{base} Jahre',
        centuries: 'Jahrhunderte',
    },
};
//# sourceMappingURL=translations.js.map